export const mediaDocumentUrl = (
  path: string,
  env = "prod" as "dev" | "test" | "prodtest" | "stage" | "prod" | "sandbox" | "local",
  mapping?: string,
) => {
  if (env == "prodtest" || env == "test" || env == "sandbox") env = "stage";
  if (env == "local") env = "dev";

  const generateCacheBusiting = Date.now();

  return `https://${env != "prod" ? `${env}-` : ""}media.banknorwegian.com${
    mapping ? "/" + mapping : ""
  }${path}?v=${generateCacheBusiting}`;
};
